import { XandrAdService } from "@almamedia/amr-adtech-stack/lib/services/ads";
import { AlmaB2CCmpService } from "@almamedia/amr-adtech-stack/lib/services/cmp";
import { DataLayerService } from "@almamedia/amr-adtech-stack/lib/services/dataLayer";
import AlmaDmpService from "@almamedia/amr-adtech-stack/lib/services/dmp/almadmp";
import NativeAdsService from "@almamedia/amr-adtech-stack/lib/services/native/native-ads";
import { GravitoService } from "@almamedia/amr-adtech-stack/lib/services/gravito";
import { LazyloadService } from "@almamedia/amr-adtech-stack/lib/services/lazyload";
import { BrandsafetyService } from "@almamedia/amr-adtech-stack/lib/services/brandsafety";
import { MetaApiService } from "@almamedia/amr-adtech-stack/lib/services/meta-api";
import {
  SiteId,
  ContentSystem,
} from "@almamedia/amr-adtech-stack/lib/services/meta-api/query";
import AlmaPermutiveService from "@almamedia/amr-adtech-stack/lib/services/dmp/providers/permutive/permutive";
// import { PrebidService } from "@almamedia/amr-adtech-stack/lib/services/prebid/prebid";
import { defaultGravitoConfiguration } from "@almamedia/amr-adtech-stack/lib/services/gravito/gravito";
import { thirdPartyCookiesEnabled } from "@almamedia/amr-adtech-stack/lib/shared/cookiecheck/cookie-check";
import GeoService from "@almamedia/amr-adtech-stack/lib/services/geo/geo";
import AlmaOneplusXService from "@almamedia/amr-adtech-stack/lib/services/dmp/providers/1plusx/1plusx";
import { StackContext } from "./context";
import dataLayer, { ICustomVariables } from "./data-layer/data-layer";
import dmp from "./dmp/dmp";
import ads from "./ads/ads";
import lazyload from "./lazyload/lazyload";
import nativeAds, { SiteNativeTemplate } from "./native/native";
import permutiveConfig from "./dmp/permutive";
import oneplusXConfig from "./dmp/oneplusx";
// import prebid from "./prebid/prebid";

async function initStack(): Promise<void> {
  const adtechStack: StackContext = { services: {} };

  adtechStack.services.almaCmpService = new AlmaB2CCmpService({}, adtechStack);

  adtechStack.services.gravitoService = new GravitoService(
    {
      enabled: true,
      defaults: {
        ...defaultGravitoConfiguration.defaults,
        shouldSendOPUid: async (): Promise<boolean> => {
          try {
            const result = await thirdPartyCookiesEnabled(50);
            return !result;
          } catch (unused) {
            return false;
          }
        },
      },
    },
    adtechStack
  );
  await adtechStack.services.gravitoService.bootstrapService();

  adtechStack.services.dataLayerService = new DataLayerService<
    ICustomVariables,
    SiteNativeTemplate
  >(dataLayer, adtechStack);

  adtechStack.services.metaApiService = new MetaApiService(
    {
      enabled: true,
      defaults: {
        siteId: "kl" as SiteId,
        contentSystem: ContentSystem.OpenContent,
        timeout: 400,
      },
    },
    adtechStack
  );

  adtechStack.services.brandsafetyService = new BrandsafetyService(
    {
      ads: {
        enabled: true,
        rawSemanticsMin: 10,
        rawSemanticsMax: 100,
      },
    },
    adtechStack
  );

  adtechStack.services.geoService = new GeoService(adtechStack, {
    useV1: true,
  });
  await adtechStack.services.geoService.bootstrapService();

  adtechStack.services.almaPermutiveService = new AlmaPermutiveService(
    adtechStack,
    permutiveConfig
  );
  await adtechStack.services.almaPermutiveService?.init();

  adtechStack.services.almaOneplusXService = new AlmaOneplusXService(
    adtechStack,
    oneplusXConfig
  );
  await adtechStack.services.almaOneplusXService?.init();

  adtechStack.services.almaDmpService = new AlmaDmpService(dmp, adtechStack);
  await adtechStack.services.almaDmpService.init();

  adtechStack.services.lazyloadService = new LazyloadService(
    lazyload,
    adtechStack
  );
  adtechStack.services.lazyloadService.initLazyloader();

  adtechStack.services.nativeAdsService = new NativeAdsService(
    nativeAds,
    adtechStack
  );

  // adtechStack.services.prebidService = new PrebidService(prebid, adtechStack);

  adtechStack.services.adsService = new XandrAdService(ads, adtechStack);
  await adtechStack.services.adsService.bootstrapService();
}

initStack();
